<template>
<div class="reseller-list">
    <div class="container">
        <h1>{{ $t("reseller.title") }}</h1>
        <p>{{ $t("reseller.description") }}</p>
        <div class="contacts-grid">
            <div v-for="member in teamMembers" :key="member.id" class="contact-card">
                <div class="avatar">
                    <img :src="member.avatar" :alt="member.name" @click="skipUserInfo(member)">
                </div>
                <div class="contact-info">
                    <h2>{{ member.name }}</h2>
                    <p class="title">{{ member.title }}</p>
                </div>
                <div class="social-links">
                    <a v-if="member.whatsapp" :href="'https://wa.me/' + member.whatsapp" class="whatsapp">
                        <img src="../../assets/reseller/WhatsApp.svg" alt="WhatsApp">
                    </a>
                    <a v-if="member.telegram" :href="'https://t.me/' + member.telegram" class="telegram">
                        <img src="../../assets/reseller/Telegram-512.webp" alt="Telegram">
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
  name: 'ResellerList',
  data() {
    return {
      teamMembers: [],
      turkishTeamMembers: [
        {
          id: 1,
          name: 'PANDA🐼ELMAS BANK🐼',
          title: 'ID: 5665144',
          avatar: 'https://image.pocketliveapp.com/image/icon/20250708/fc25f2b4887445f8afcf6675d1ea8e1b.jpg.200.jpg',
          whatsapp: '905397098153',
          uid: 5665144
        },
        {
          id: 2,
          name: '🅱️EN🙏KİMİM BAYİİ',
          title: 'ID: 5665094',
          avatar: 'https://image.pocketliveapp.com/image/icon/20250208/eca26e5192554e59bf424205a17223e2.jpg.200.jpg',
          whatsapp: '79207066060',
          uid: 5665094
        },
        {
          id: 3,
          name: '♦️Romeo 7/24 Bayi♦',
          title: 'ID: 6746122',
          avatar: 'https://image.pocketliveapp.com/image/icon/20250708/7b3d842b32e84c029306b989bc72f1bd.jpg.200.jpg',
          whatsapp: '905514865689',
          uid: 6746122
        },
        {
          id: 4,
          name: '📽🤪αғαcαп вαтυ🤪',
          title: 'ID: 4345314',
          avatar: 'https://image.laylachat.com/image/icon/20241216/eae47925152249d9bc096f933f01f497.jpg.200.jpg',
          whatsapp: '905069894548',
          uid: 4345314
        },
        {
          id: 5,
          name: '💎ELMAS BANK💎DEJAVU',
          title: 'ID: 5670877',
          avatar: 'https://image.laylachat.com/image/icon/20241222/44c34c6af9924869b99e08bb7024757e.jpg.200.jpg',
          whatsapp: '905348238174',
          uid: 5670877
        },
        {
          id: 6,
          name: '🧚ɛʐɢɨ̇ᵖᵃᵗʳᵒᶰᶤᶜᵉ',
          title: 'ID: 6526424',
          avatar: 'https://image.pocketliveapp.com/image/icon/20250727/d079c29f1e274cae9a7033e43add4ab1.jpg.200.jpg',
          whatsapp: '905325137798',
          uid: 6526424
        },
        {
          id: 7,
          name: 'ᵐᵒᵒᵈʸGeronimo',
          title: 'ID: 5853530',
          avatar: 'https://image.laylachat.com/image/icon/20250104/1ac87321f9324185aa251994467fc1e0.jpg.200.jpg',
          whatsapp: '244953102163',
          uid: 5853530
        },
        {
          id: 8,
          name: '🕊️ʏᴀᴋᴀᴍᴏᴢ ᴇʟᴍᴀs ʙᴀʏɪ̇💎',
          title: 'ID: 6409293',
          avatar: 'https://image.pocketliveapp.com/image/icon/20250618/41f39f05ccf0440c8fc126a7cca9c139.jpg.200.jpg',
          whatsapp: '18566319820',
          uid: 6409293
        },
        {
          id: 9,
          name: '✵şᴜʟє⚚',
          title: 'ID: 6061342',
          avatar: 'https://image.pocketliveapp.com/image/icon/20250712/c36963a86e48433d8e6f8c99b2f2bb42.jpg.200.jpg',
          whatsapp: '905386364393',
          uid: 6061342
        },
        {
          id: 10,
          name: '💎ʀᴇꜱᴜʟ💎ʀᴇꜱᴛ ᴀᴊᴀɴꜱ®',
          title: 'ID: 5669815',
          avatar: 'https://image.pocketliveapp.com/image/icon/20250718/41d4606b2f204e7d929d0ea9732c6549.jpg.200.jpg',
          whatsapp: '905010305683',
          uid: 5669815
        },
        {
          id: 11,
          name: '🇹🇷₮ıϻ💎Bank💕Z',
          title: 'ID: 5664948',
          avatar: 'https://image.pocketliveapp.com/image/icon/20250315/78212a336e7c4b7a85ccc452ec5076b9.jpg.200.jpg',
          whatsapp: '905400202156',
          uid: 5664948
        },
        {
          id: 12,
          name: '🐉𝐁𝐄𝐑𝐋İ𝐍 𝐀𝐉𝐀𝐍𝐒🔱',
          title: 'ID: 7453439',
          avatar: 'https://image.pocketliveapp.com/image/icon/20250708/235d751c5d214b0995bffdb672d2c804.jpg.200.jpg',
          whatsapp: '905380115606',
          uid: 7453439
        },
      ],
      spanishTeamMembers: [
        {
          id: 1,
          name: 'Darlyz',
          title: 'ID: 3397802',
          avatar: 'https://image.pocketliveapp.com/image/auth_icon/20250313/042f6e475dff4dc692f7b92a9c55d0af.jpg.200.jpg',
          whatsapp: '595983133085',
          uid: 3397802
        },
        {
          id: 2,
          name: 'Frida',
          title: 'ID: 6354659',
          avatar: 'https://image.pocketliveapp.com/image/auth_icon/20250308/75691e0ad92d4d0582a4e39824ad0828.jpg.200.jpg',
          whatsapp: '5212211890689',
          uid: 6354659
        },
        {
          id: 3,
          name: 'Juan',
          title: 'ID: 5930654',
          avatar: 'https://image.pocketliveapp.com/image/photo/20250114/b309e865a78245628a6c054a8003738e.jpg.200.jpg',
          whatsapp: '5491137058745',
          uid: 5930654
        },
        {
          id: 4,
          name: 'Cristal',
          title: 'ID: 4190768',
          avatar: 'https://image.pocketliveapp.com/image/auth_icon/20250311/59edb9de1b334875b80ec96b7bea4bb6.jpg.200.jpg',
          whatsapp: '584121229112',
          uid: 4190768
        },
        {
          id: 5,
          name: 'Lisy ',
          title: 'ID: 4262959',
          avatar: 'https://image.pocketliveapp.com/image/icon/20250313/d67115c9f7434e8aaa7fa59438134f54.jpg.200.jpg',
          whatsapp: '573124995883',
          uid: 4262959
        }
      ],
      userInfo: [],
    }
  },
  created() {
    this.judgeClient();
    this.initLanguage();
    this.initTeamMembers();
    document.title = this.$t("reseller.pageTitle");
  },
  watch: {
    '$route.query': {
      handler() {
        this.initTeamMembers();
      },
      immediate: true
    }
  },
  methods: {
    initLanguage() {
      // 获取用户语言设置
      const userLang = this.userInfo.lang || navigator.language || 'en';
      const langs = userLang.substring(0, 2);
      const lang = userLang;

      if (langs == "zh") {
        if (lang == "zh_TW" || lang == "zh_HK") {
          this.$i18n.locale = "tc";
        } else {
          this.$i18n.locale = "zh";
        }
      } else if (langs == "ar") {
        this.$i18n.locale = "ar";
      } else if (langs == "tr") {
        this.$i18n.locale = "tr";
      } else if (langs == "pt") {
        this.$i18n.locale = "pt";
      } else if (langs == "es") {
        this.$i18n.locale = "es";
      } else if (langs == "fr") {
        this.$i18n.locale = "fr"
      } else if (langs == "id") {
        this.$i18n.locale = "id"
      } else if (langs == "ms") {
        this.$i18n.locale = "ms"
      } else {
        this.$i18n.locale = "en";
      }

      document.querySelector("html").setAttribute("lang", this.$i18n.locale);
    },
    initTeamMembers() {
      const region = this.$route.query.region;
      if (region === 'es') {
        this.teamMembers = this.spanishTeamMembers;
      } else {
        this.teamMembers = this.turkishTeamMembers;
      }
    },
    skipUserInfo(item) {
      let uid = item.uid;
      
      if (this.client == 'iOS') {
        window["webkit"].messageHandlers['skipUserInfo'].postMessage(JSON.stringify(uid));
      } else if (this.client == 'Android') {
        nativeJs["skipUserInfo"](JSON.stringify(uid));
      }
    },
    judgeClient() {
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { //判断iPhone|iPad|iPod|iOS
        this.client = 'iOS';
      } else if (/(Android)/i.test(navigator.userAgent)) { //判断Android
        this.client = 'Android';
      } else {
        this.client = 'PC';
      }
      return this.client;
    },
  }
}
</script>

<style scoped>

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

body {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    background: #F5F6F8;
    color: #ffffff;
    line-height: 1.47059;
    min-height: 100vh;
    position: relative;
    overflow: hidden;
}

.reseller-list {
    min-height: 100vh;
    width: 100%;
    position: relative;
    overflow: hidden;
    background: #F5F6F8;
}

/* 确保内容在背景之上 */
.container {
    position: relative;
    z-index: 2;
    padding: 20px 15px;
    max-width: 100%;
    margin: 0 auto;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
}

.contacts-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(450px, 1fr));
    gap: 20px;
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
}

/* 卡片样式更新 */
.contact-card {
    background: rgba(255, 255, 255, 0.25);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border-radius: 24px;
    padding: 30px 36px;
    display: flex;
    align-items: center;
    gap: 18px;
    border: 1px solid rgba(255, 255, 255, 0.3);
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.1);
    margin-bottom: 15px;
    width: 100%;
    min-width: 0;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
}

.contact-card:active {
    transform: scale(0.98);
    background: rgba(255, 255, 255, 0.3);
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.avatar {
    width: 96px;
    height: 96px;
    border-radius: 96px;
    overflow: hidden;
    border: 2px solid rgba(255, 255, 255, 0.2);
    flex-shrink: 0;
    position: relative;
    z-index: 2;
}

.image-container {
    width: 100%;
    height: 100%;
    position: relative;
    z-index: 2;
}

.avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    position: relative;
    z-index: 2;
}

.contact-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    min-width: 0;
    flex: 1;
}

h2 {
    font-size: 30px !important;
    font-weight: 600;
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    color: #262427;
}

.title {
    color: #89848D;
    font-size: 24px !important;
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
}

/* 社交图标样式 */
.social-links {
    display: flex;
    gap: 24px;
    margin-left: auto;
    flex-shrink: 0;
}

.social-links a {
    width: 72px;
    height: 72px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #F0F2F5;
    border-radius: 50%;
    transition: all 0.2s ease;
    position: relative;
}

.social-links a:active {
    transform: scale(0.95);
    background: rgba(137, 132, 141, 0.1);
}

.social-links img {
    width: 48px;
    height: 48px;
}

/* 添加点击涟漪效果 */
.social-links a::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.4) 0%, transparent 70%);
    opacity: 0;
    transform: scale(2);
    transition: opacity 0.5s ease-out, transform 0.5s ease-out;
}

.social-links a:active::after {
    opacity: 1;
    transform: scale(0);
}

/* 标题样式 */
h1 {
    text-align: center;
    font-size: 48px !important;
    font-weight: 600;
    margin-bottom: 24px;
    color: #262427;
}

/* 添加说明文字样式 */
.container > p {
    text-align: center;
    font-size: 24px !important;
    color: #89848D;
    margin-bottom: 48px;
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
    line-height: 1.5;
    opacity: 0.8;
}


/* 安全区域适配 */
@supports (padding: max(0px)) {
    .container {
        padding-left: max(15px, env(safe-area-inset-left));
        padding-right: max(15px, env(safe-area-inset-right));
        padding-bottom: max(15px, env(safe-area-inset-bottom));
    }
}

/* 移动端适配 */
@media (max-width: 390px) {
    .contact-card {
        padding: 15px 18px;
        gap: 15px;
    }

    .avatar {
        width: 84px;
        height: 84px;
        border-radius: 96px;
    }

    h1 {
        font-size: 42px !important;
    }

    h2 {
        font-size: 27px !important;
    }

    .title {
        font-size: 21px !important;
    }

    .social-links {
        gap: 16px;
    }

    .social-links a {
        width: 60px;
        height: 60px;
    }

    .social-links img {
        width: 40px;
        height: 40px;
    }

    .container > p {
        font-size: 24px !important;
        margin-bottom: 36px;
        padding: 0 20px;
    }
}

/* 优化移动端触摸体验 */
@media (hover: none) {
    .contact-card:hover {
        transform: none;
    }
    
    .social-links a:hover {
        transform: none;
    }

}

/* 确保在移动端的性能 */
@media (prefers-reduced-motion: reduce) {
    .contact-card,
    .social-links a,
    .floating-circles,
    .wave,
    .background-animation {
        transition: none;
    }
}

.image-container {
    width: 200px;
    height: 200px;
    background: #fff;
}

.team-member-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
    opacity: 0;
    transition: opacity 0.3s;
}

.team-member-image.is-loaded {
    opacity: 1;
}


</style>

